import { apiWrapper } from "@/services/api";

export const postStopSubscription = async (book_group_id) => {
  try {
    const apiParams = { book_group_id: book_group_id };

    const resp = await apiWrapper("POST", `stop-subscription`, apiParams);
    return resp.data;
  } catch (err) {
    console.log('ERROR"" postStopSubscription()');
    throw err;
  }
};
